import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type ClassNamesTypes = {
  root?: string;
  label?: string;
  input?: string;
  pLabel?: string;
};

type PropTypes = {
  id: string;
  label?: string;
  register?: any;
  checked?: boolean;
  disabled?: boolean;
  classNames?: ClassNamesTypes;
  defaultChecked?: boolean;
};

const CheckboxNew: FC<PropTypes> = ({
  id,
  register,
  checked,
  disabled = false,
  label,
  classNames,
  defaultChecked = false,
}) => {
  return (
    <label
      className={twMerge(
        `flex cursor-pointer select-none items-center gap-x-2 text-left text-sm`,
        classNames?.label
      )}
      htmlFor={id}>
      <input
        id={id}
        className='peer absolute z-1 cursor-pointer opacity-0'
        type='checkbox'
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        {...register(id)}
      />
      <span
        className={twMerge(
          `relative h-4 w-4 rounded-xs border border-black/20 hover:border-fig peer-checked:border-transparent peer-checked:bg-fig peer-checked:after:absolute peer-checked:after:left-[3.2px] peer-checked:after:-top-px peer-checked:after:h-[12px] peer-checked:after:w-[7px] peer-checked:after:rotate-45 peer-checked:after:border-b-[3px] peer-checked:after:border-r-[3px] peer-checked:after:border-white peer-checked:after:content-['']`,
          classNames?.input
        )}
      />
      <p className={twMerge('flex-1', classNames?.pLabel)}>{label}</p>
    </label>
  );
};

export default CheckboxNew;
